/* eslint-disable regex/invalid */
import checkboxChecked from '@images/svg/checkbox-checked.svg'
import checkboxIndeterminate from '@images/svg/checkbox-indeterminate.svg'
import checkboxUnchecked from '@images/svg/checkbox-unchecked.svg'
import radioChecked from '@images/svg/radio-checked.svg'
import radioUnchecked from '@images/svg/radio-unchecked.svg'

// ucs custom icons
import acceptance_icon from '@images/svg/acceptance_icon.svg'
import account_breakdown_icon from '@images/svg/account_breakdown_icon.svg'
import account_details_icon from '@images/svg/account_details_icon.svg'
import analytics_icon from '@images/svg/chart.svg'
import assignment_icon from '@images/svg/assignment_icon.svg'
import assigned_icon from '@images/svg/assigned_icon.svg'
import assigned_items_icon from '@images/svg/assigned_items_icon.svg'
import arrow_down_icon from '@images/svg/arrow_down_icon.svg'
import arrow_left_icon from '@images/svg/arrow_left_icon.svg'
import arrow_right_icon from '@images/svg/arrow_right_icon.svg'
import arrow_up_icon from '@images/svg/arrow_up_icon.svg'
import branch_icon from '@images/svg/branch_icon.svg'
import building_icon from '@images/svg/building_icon.svg'
import calendar_icon from '@images/svg/calendar_icon.svg'
import calendar31_icon from '@images/svg/calendar31_icon.svg'
import chart_icon from '@images/svg/chart_icon.svg'
import check_circle_icon from '@images/svg/check_circle_icon.svg'
import check_curly_circle_icon from '@images/svg/check_curly_circle_icon.svg'
import check_square_icon from '@images/svg/check_square_icon.svg'
import close_icon from '@images/svg/close_icon.svg'
import dashboard_icon from '@images/svg/dashboard_icon.svg'
import datepicker_icon from '@images/svg/datepicker_icon.svg'
import database_icon from '@images/svg/database_icon.svg'
import delete_icon from '@images/svg/delete_icon.svg'
import dropdown_menu_icon from '@images/svg/dropdown_menu_icon.svg'
import exception_icon from '@images/svg/exception_icon.svg'
import export_icon from '@images/svg/export_icon.svg'
import filter_icon from '@images/svg/filter_icon.svg'
import filter_collapse_icon from '@images/svg/filter_collapse_icon.svg'
import filter_expand_icon from '@images/svg/filter_expand_icon.svg'
import forward_action_icon from '@images/svg/forward_action_icon.svg'
import forwarding_icon from '@images/svg/forwarding_icon.svg'
import global_search_icon from '@images/svg/global_search_icon.svg'
import hide_password_icon from '@images/svg/hide_password_icon.svg'
import id_icon from '@images/svg/id_icon.svg'
import location_icon from '@images/svg/location_icon.svg'
import logout_icon from '@images/svg/logout_icon.svg'
import logout_arrow_icon from '@images/svg/logout_arrow_icon.svg'
import logout_box_icon from '@images/svg/logout_box_icon.svg'
import ms_logo_icon from '@images/svg/ms_logo_icon.svg'
import nav_toggle_icon from '@images/svg/nav_toggle_icon.svg'
import no_data_avail from '@images/svg/no_data_avail.svg'
import owner_icon from '@images/svg/owner_icon.svg'
import page_down_icon from '@images/svg/page_down_icon.svg'
import page_up_icon from '@images/svg/page_up_icon.svg'
import pagination_dropdown_icon from '@images/svg/pagination_dropdown_icon.svg'
import pagination_first_page_icon from '@images/svg/pagination_first_page_icon.svg'
import pagination_last_page_icon from '@images/svg/pagination_last_page_icon.svg'
import pagination_next_page_icon from '@images/svg/pagination_next_page_icon.svg'
import pagination_prev_page_icon from '@images/svg/pagination_prev_page_icon.svg'
import pie_chart_icon from '@images/svg/pie_chart_icon.svg'
import processing_icon from '@images/svg/processing_icon.svg'
import proxy_icon from '@images/svg/proxy_icon.svg'
import proxy_unlink_icon from '@images/svg/proxy_unlink_icon.svg'
import quantity_icon from '@images/svg/quantity_icon.svg'
import recall_icon from '@images/svg/recall_icon.svg'
import reload_icon from '@images/svg/reload_icon.svg'
import reload2_icon from '@images/svg/reload2_icon.svg'
import return_icon from '@images/svg/return_icon.svg'
import return2_icon from '@images/svg/return2_icon.svg'
import scan_icon from '@images/svg/scan_icon.svg'
import search from '@images/svg/search.svg'
import search_scan from '@images/svg/search_scan.svg'
import search_icon from '@images/svg/search_icon.svg'
import show_password_icon from '@images/svg/show_password_icon.svg'
import status_icon from '@images/svg/status_icon.svg'
import switch_account_active_icon from '@images/svg/switch_account_active_icon.svg'
import switch_account_inactive_icon from '@images/svg/switch_account_inactive_icon.svg'
import total_tras_icon from '@images/svg/total_tras_icon.svg'
import trans_type_icon from '@images/svg/trans_type_icon.svg'
import user_icon from '@images/svg/user_icon.svg'
import user_management from '@images/svg/user_management.svg'
import warning_icon from '@images/svg/warning_icon.svg'
import weight_icon from '@images/svg/weight_icon.svg'

const customIcons = {
    'mdi-checkbox-blank-outline': checkboxUnchecked,
    'mdi-checkbox-marked': checkboxChecked,
    'mdi-minus-box': checkboxIndeterminate,
    'mdi-radiobox-marked': radioChecked,
    'mdi-radiobox-blank': radioUnchecked,

    // ucs custom icons
    'ucsi-acceptance': acceptance_icon,
    'ucsi-account-breakdown': account_breakdown_icon,
    'ucsi-account-details': account_details_icon,
    'ucsi-assignment': assignment_icon,
    'ucsi-analytics': analytics_icon,
    'ucsi-assigned': assigned_icon,
    'ucsi-assigned-items': assigned_items_icon,
    'ucsi-arrow-down': arrow_down_icon,
    'ucsi-arrow-left': arrow_left_icon,
    'ucsi-arrow-right': arrow_right_icon,
    'ucsi-arrow-up': arrow_up_icon,
    'ucsi-branch': branch_icon,
    'ucsi-building': building_icon,
    'ucsi-calendar': calendar_icon,
    'ucsi-calendar31': calendar31_icon,
    'ucsi-chart': chart_icon,
    'ucsi-check-circle': check_circle_icon,
    'ucsi-check-curly-circle': check_curly_circle_icon,
    'ucsi-check-square': check_square_icon,
    'ucsi-close': close_icon,
    'ucsi-database': database_icon,
    'ucsi-datepicker': datepicker_icon,
    'ucsi-dashboard': dashboard_icon,
    'ucsi-delete': delete_icon,
    'ucsi-dropdown-menu': dropdown_menu_icon,
    'ucsi-exception': exception_icon,
    'ucsi-export': export_icon,
    'ucsi-filter': filter_icon,
    'ucsi-filter-collapse': filter_collapse_icon,
    'ucsi-filter-expand': filter_expand_icon,
    'ucsi-forward-action': forward_action_icon,
    'ucsi-forwarding': forwarding_icon,
    'ucsi-global-search': global_search_icon,
    'ucsi-hide-password': hide_password_icon,
    'ucsi-id': id_icon,
    'ucsi-location': location_icon,
    'ucsi-logout': logout_icon,
    'ucsi-logout-arrow': logout_arrow_icon,
    'ucsi-logout-box': logout_box_icon,
    'ucsi-ms-logo': ms_logo_icon,
    'ucsi-nav-toggle': nav_toggle_icon,
    'ucsi-no-data-avail-placeholder': no_data_avail,
    'ucsi-owner': owner_icon,
    'ucsi-page-down': page_down_icon,
    'ucsi-page-up': page_up_icon,
    'ucsi-pagination-dropdown': pagination_dropdown_icon,
    'ucsi-pagination-first-page': pagination_first_page_icon,
    'ucsi-pagination-last-page': pagination_last_page_icon,
    'ucsi-pagination-next-page': pagination_next_page_icon,
    'ucsi-pagination-prev-page': pagination_prev_page_icon,
    'ucsi-pie-chart': pie_chart_icon,
    'ucsi-processing': processing_icon,
    'ucsi-proxy': proxy_icon,
    'ucsi-proxy-unlink': proxy_unlink_icon,
    'ucsi-quantity': quantity_icon,
    'ucsi-recall': recall_icon,
    'ucsi-reload': reload_icon,
    'ucsi-reload2': reload2_icon,
    'ucsi-return': return_icon,
    'ucsi-return2': return2_icon,
    'ucsi-scan': scan_icon,
    'ucsi-search': search_icon,
    'ucsi-search-placeholder': search,
    'ucsi-search-scan-placeholder': search_scan,
    'ucsi-show-password': show_password_icon,
    'ucsi-status': status_icon,
    'ucsi-switch-account-active': switch_account_active_icon,
    'ucsi-switch-account-inactive': switch_account_inactive_icon,
    'ucsi-total-tras': total_tras_icon,
    'ucsi-trans-type': trans_type_icon,
    'ucsi-user': user_icon,
    'ucsi-user-management': user_management,
    'ucsi-warning': warning_icon,
    'ucsi-weight': weight_icon,
}

const aliases = {
    info: 'ri-error-warning-line',
    success: 'ri-checkbox-circle-line',
    warning: 'ri-alert-line',
    error: 'ri-error-warning-line',
    calendar: 'ri-calendar-2-line',
    collapse: 'ri-arrow-up-s-line',
    complete: 'ri-check-line',
    cancel: 'ri-close-line',
    close: 'ri-close-line',
    delete: 'ri-close-circle-fill',
    clear: 'ri-close-line',
    prev: 'ri-arrow-left-s-line',
    next: 'ri-arrow-right-s-line',
    delimiter: 'ri-circle-line',
    sort: 'ri-arrow-up-line',
    expand: 'ri-arrow-down-s-line',
    menu: 'ri-menu-line',
    subgroup: 'ri-arrow-down-s-fill',
    dropdown: 'ri-arrow-down-s-line',
    edit: 'ri-pencil-line',
    ratingEmpty: 'ri-star-line',
    ratingFull: 'ri-star-fill',
    ratingHalf: 'ri-star-half-line',
    loading: 'ri-refresh-line',
    first: 'ri-skip-back-mini-line',
    last: 'ri-skip-forward-mini-line',
    unfold: 'ri-split-cells-vertical',
    file: 'ri-attachment-2',
    plus: 'ri-add-line',
    minus: 'ri-subtract-line',
    sortAsc: 'ri-arrow-up-line',
    sortDesc: 'ri-arrow-down-line',
    usersMgt: 'ri-group-2-line',
}

/* eslint-enable */
export const iconify = {
    component: (props) => {
        // Load custom SVG directly instead of going through icon component
        if (typeof props.icon === 'string') {
            const iconComponent = customIcons[props.icon]
            if (iconComponent) return h(iconComponent)
        }

        return h(props.tag, {
            ...props,

            // As we are using class based icons
            class: [props.icon],

            // Remove used props from DOM rendering
            tag: undefined,
            icon: undefined,
        })
    },
}
export const icons = {
    defaultSet: 'iconify',
    aliases,
    sets: {
        iconify,
    },
}
